// Shared constants used across pages — single source of truth.

export const AU_STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];
export const AU_STATES_WITH_BLANK = ["", ...AU_STATES];
export const WWCC_TYPE_OPTIONS = [
  "ACT Working with Vulnerable People",
  "NSW Working with Children Check",
  "NT Ochre Card",
  "QLD Blue Card",
  "SA Working with Children Check",
  "TAS Working with Vulnerable People",
  "VIC Working with Children Check",
  "WA Working with Children Check",
];

/** Maps AU state code to the official check name for that jurisdiction. */
export const WWCC_TYPE_BY_STATE = {
  ACT: "ACT Working with Vulnerable People",
  NSW: "NSW Working with Children Check",
  NT: "NT Ochre Card",
  QLD: "QLD Blue Card",
  SA: "SA Working with Children Check",
  TAS: "TAS Working with Vulnerable People",
  VIC: "VIC Working with Children Check",
  WA: "WA Working with Children Check",
};

export const WWCC_STATE_FROM_TYPE = Object.fromEntries(
  Object.entries(WWCC_TYPE_BY_STATE).map(([state, type]) => [type, state])
);

export const TIER_LABEL = {
  standard: "Standard",
  advanced: "Advanced",
  premium: "Premium",
  general: "General Profile",
};

export const TIER_PRICE = {
  standard: 55,
  advanced: 70,
  premium: 90,
};

export const REWARD_LABEL = {
  none: "",
  active: "Active",
  growth: "Growth",
  core: "Core",
  elite: "Elite",
};

export const CURRICULA_FEATURED = ["SACE", "VCE", "HSC", "QCE", "WACE", "TCE", "IB", "UCAT", "OTHER"];

export const CURRICULUM_LABEL_OVERRIDES = {
  IB: "IB - international baccalaureate",
  HS: "High School Support",
  PS: "Primary School Support",
  UCAT: "UCAT ANZ - National",
  MED: "Medicine / Dentistry Interviews - National",
  OTHER: "Admissions Tests & Interviews - National",
};

/** Soft page chrome for tier profile editors (onboarding + edit profile). */
export const TIER_PAGE_TINT = {
  standard: {
    panel: "bg-[linear-gradient(180deg,rgba(241,245,249,0.95),rgba(255,255,255,0.92))] border-slate-200/90",
    header: "text-slate-700",
    accent: "bg-slate-500",
    tab: "border-slate-300 text-slate-700 data-[active=true]:bg-slate-100 data-[active=true]:border-slate-400",
  },
  advanced: {
    panel: "bg-[linear-gradient(180deg,rgba(232,237,255,0.96),rgba(255,255,255,0.94))] border-aus-cobalt/25",
    header: "text-aus-cobalt",
    accent: "bg-aus-cobalt",
    tab: "border-aus-cobalt/30 text-aus-cobalt data-[active=true]:bg-[#e8edff] data-[active=true]:border-aus-cobalt/50",
  },
  premium: {
    panel: "bg-[linear-gradient(180deg,rgba(253,230,138,0.35),rgba(255,255,255,0.94))] border-amber-300/50",
    header: "text-amber-900",
    accent: "bg-amber-500",
    tab: "border-amber-300/60 text-amber-900 data-[active=true]:bg-amber-50 data-[active=true]:border-amber-400",
  },
  general: {
    panel: "bg-[linear-gradient(180deg,rgba(236,253,245,0.9),rgba(255,255,255,0.94))] border-emerald-200/80",
    header: "text-emerald-900",
    accent: "bg-emerald-500",
    tab: "border-emerald-300/70 text-emerald-900 data-[active=true]:bg-emerald-50 data-[active=true]:border-emerald-500",
  },
};

export const formatCurriculumLabel = (code) => CURRICULUM_LABEL_OVERRIDES[code] || code;

export const formatCurriculumOptionLabel = (curriculum) => {
  if (!curriculum) return "";
  const code = curriculum.code || "";
  if (CURRICULUM_LABEL_OVERRIDES[code]) return CURRICULUM_LABEL_OVERRIDES[code];
  if (curriculum.region) return `${code} - ${curriculum.region}`;
  return code;
};

export const tierChipClass = (tier) =>
  tier === "premium"
    ? "tier-premium-chip"
    : tier === "advanced"
    ? "tier-advanced-chip"
    : "tier-standard-chip";

export const formatAUD = (n) =>
  typeof n === "number" ? `$${n.toFixed(n % 1 === 0 ? 0 : 2)}` : "$0";
